import { useEffect, useState } from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  GET_ALL_MERCHANT_BRANCHX,
  GET_ALL_MERCHANT_SURYODAY,
  GET_ALL_MERCHANT_VIMO,
} from "../../../utils/constant";
import useApiServices from "../../../utils/useApiServices";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import PayoutMasterForm from "./PayoutMasterForm";
import CustomTip from "../../../common/CustomToolTip/CustomTip";
import { MastersActionRegistry } from "../../../Privillages/ActionRegistry";
import useHasPrivilege from "../../../Privillages/useHasPrivilege";

const SubmittedPayoutMasterForm = ({ type, toggleRightBar }) => {
  const { SECTION_KEY, PAYOUT_MASTER_EDIT } = MastersActionRegistry;
  const hasEditPayoutMasters = useHasPrivilege(SECTION_KEY, PAYOUT_MASTER_EDIT);
  const [applications, setApplications] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [activeProvider, setActiveProvider] = useState("branchx");
  const [show, setShow] = useState(false);
  const { apiCallFnforGet } = useApiServices();

  const getColumns = () => {
    if (activeProvider === "branchx") {
      return [
        { headerName: "Merchant ID", field: "mid", width: 150 },
        { headerName: "User Name", field: "username", width: 190 },
        {
          headerName: "Vehicle Master Name",
          field: "vehicleMasterName",
          width: 210,
        },
        {
          headerName: "Merchant Master Name",
          field: "masterMerchantName",
          width: 190,
        },
        { headerName: "Client ID", field: "clientId", width: 150 },
        { headerName: "Client Secret", field: "clientSecrete", width: 230 },
        {
          headerName: "Account Module Secret",
          field: "accountsModuleSecrete",
          width: 210,
        },
        {
          headerName: "Payment Module Secret",
          field: "paymentModuleSecrete",
          width: 210,
        },
        { headerName: "Provider Secret", field: "providerSecrete", width: 220 },
        {
          headerName: "master Virtual Account",
          field: "masterVirtualAccount",
          width: 180,
        },
        { headerName: "Transfer Type", field: "transferType", width: 150 },
        { headerName: "Bank Name", field: "bankName", width: 200 },
        { headerName: "Master Alius ID", field: "masterAliusId", width: 200 },
        { headerName: "MVA Customer ID", field: "mvaCustomerId", width: 180 },
        {
          headerName: "MVA Mobile Number",
          field: "mvaMobileNumber",
          width: 180,
        },
        { headerName: "Max Txn Amount", field: "max_txn_amount", width: 180 },
        // { headerName: "Action", field: "action", minWidth: 100 }
      ];
    }

    if (activeProvider === "suryoday") {
      return [
        { headerName: "Merchant ID", field: "mid", width: 150 },
        { headerName: "Username", field: "username", width: 200 },
        {
          headerName: "Vehicle Master Name",
          field: "vehicleMesterName",
          width: 210,
        },
        {
          headerName: "Merchant Master Name",
          field: "masterMerchantName",
          width: 190,
        },
        { headerName: "Client ID", field: "clientId", width: 180 },
        {
          headerName: "Payment Module Secret",
          field: "paymentModuleSecret",
          width: 230,
        },
        { headerName: "Secret Key", field: "secretKey", width: 200 },
        { headerName: "Login Username", field: "loginUsername", width: 220 },
        { headerName: "Login Password", field: "loginPassword", width: 220 },
        { headerName: "Auth Token", field: "authToken", width: 200 },
        { headerName: "VPA", field: "vpa", width: 200 },
        {
          headerName: "Bank Onboarded MID",
          field: "bankOnboardedMid",
          width: 230,
        },
        { headerName: "Transfer Type", field: "transferType", width: 150 },
        { headerName: "Master Alius ID", field: "masterAliusId", width: 220 },
        { headerName: "Bank Name", field: "bankName", width: 200 },
        { headerName: "Max Txn Amount", field: "max_txn_amt", width: 180 },
        { headerName: "Password", field: "password", width: 220 },
        // { headerName: "Action", field: "action", minWidth: 100 },
      ];
    }

    if (activeProvider === "vimo") {
      return [
        { headerName: "Merchant ID", field: "mid", width: 150 },
        { headerName: "User Name", field: "username", width: 180 },
        { headerName: "Password", field: "password", width: 200 },
        { headerName: "Transfer Type", field: "transferType", width: 150 },
        { headerName: "Max Txn Amount", field: "max_txn_amt", width: 180 },
        { headerName: "Bank Name", field: "bankName", width: 200 },
        {
          headerName: "Master Merchant",
          field: "masterMerchantName",
          width: 190,
        },
        {
          headerName: "Vehicle Master",
          field: "vehicleMasterName",
          width: 210,
        },
        { headerName: "Client ID", field: "clientId", width: 170 },
        { headerName: "Alias ID", field: "masterAliusId", width: 180 },
        { headerName: "Salt Key", field: "saltKey", width: 180 },
        {
          headerName: "Secret Key",
          field: "secretKey",
          width: 180,
        },
        {
          headerName: "Encrypted Key",
          field: "encryptedDecryptedKey",
          width: 220,
        },
        {
          headerName: "Registered Mobile No",
          field: "registeredNumber",
          width: 180,
        },
        { headerName: "MCC Code", field: "mccCode", width: 120 },
      ];
    }

    return [];
  };

  const FetchData = async () => {
    try {
      let apiUrl = "";

      if (activeProvider === "branchx") {
        apiUrl = GET_ALL_MERCHANT_BRANCHX;
      } else if (activeProvider === "suryoday") {
        apiUrl = GET_ALL_MERCHANT_SURYODAY;
      } else if (activeProvider === "vimo") {
        apiUrl = GET_ALL_MERCHANT_VIMO;
      }

      const apiResponse = await apiCallFnforGet(apiUrl);

      if (apiResponse.statusCode === 200 || Array.isArray(apiResponse)) {
        const list = apiResponse.data || apiResponse;

        if (!Array.isArray(list)) return setApplications([]);

        const finalRes = list?.map((item, i) => ({
          ...item,
          id: i,
        }));

        setApplications(finalRes);
      } else {
        setApplications([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    FetchData();
  }, [activeProvider, show, refresh]);

  const handleClose = () => setShow(false);

  const handleOnClick = () => {
    setShow(true);
  };

  return (
    <div className="">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <button
              type="button"
              class="btn-close m-3"
              onClick={toggleRightBar}
            ></button>

            <div className="fs-2 text-dark fw-bold">Payout - Master </div>
          </div>

          <div className="d-flex justify-content-end ">
            <select
              className="form-select form-select-sm"
              style={{ width: "150px" }}
              value={activeProvider}
              onChange={(e) => setActiveProvider(e?.target?.value)}
            >
              <option value="branchx">BranchX</option>
              <option value="suryoday">Suryoday</option>
              <option value="vimo">Vimo</option>
            </select>
            {hasEditPayoutMasters && (
              <CustomTip size="18" placement="top" title="Payout Master Form">
                <div className="" onClick={handleOnClick}>
                  <AddCircleOutlineIcon fontSize="large" />
                </div>
              </CustomTip>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="col-12">
                <div className="card-body">
                  <div className="table-responsive">
                    <DataGrid
                      rows={applications}
                      columns={getColumns().map((column) => ({
                        ...column,
                        renderCell: (params) =>
                          column.field === "action"
                            ? params.value
                            : params.value,
                      }))}
                      slots={{
                        toolbar: GridToolbar,
                      }}
                      slotProps={{
                        toolbar: {
                          showQuickFilter: true,
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PayoutMasterForm
        show={show}
        onHide={handleClose}
        setRefresh={setRefresh}
        refresh={refresh}
      />
    </div>
  );
};

export default SubmittedPayoutMasterForm;
